import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MessageBoxReturnValue } from '@enums/message-box-return-value.enum';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})

export class MessageBoxComponent implements OnInit {
  parameters: MessageBoxParameter;

  constructor(
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageBoxParameter
  ) {
    this.parameters = data;
  }

  ngOnInit() {
  }

  onOk() {
    this.dialogRef.close({ result: MessageBoxReturnValue.ok, value: true });
  }
  onYes() {
    this.dialogRef.close({ result: MessageBoxReturnValue.yes, value: true });
  }
  onNo() {
    this.dialogRef.close({ result: MessageBoxReturnValue.no, value: false });
  }
  onCancel() {
    this.dialogRef.close({ result: MessageBoxReturnValue.cancel, value: false });
  }
}

// TODOFIX Faire un UI Service dans le Shared pour pouvoir l'ouvrir

export class MessageBox {

  static show(param: MessageBoxParameter) {
    const dialogRef = param.dialog.open(MessageBoxComponent, {
      data: {
        title: param.title || null,
        message: param.message,
        information: param.information,
        buttons: param.buttons || [],
        style: param.style || 0,
        allow_outside_click: param.allow_outside_click || false
      },
      width: param.width
    });
    return dialogRef.afterClosed();
  }
}
